<script setup lang="ts">
import { PropType, ref } from 'vue';
import { useDebounceFn } from '@vueuse/core';
import { AppCoreEnums } from '../../shared/enums';
import { useCoreStore } from '../../../stores/core/store';
import inputTextPreset from '@/presets/customizations/inputtext';

const emit = defineEmits(['search-changed']);

const props = defineProps({
  containerType: {
    type: Number as PropType<AppCoreEnums.ContainerType>,
    required: true,
  },
  width: {
    type: Number,
    default: 360,
  },
  isFullWidth: {
    type: Boolean,
    default: false,
  },
  placeholder: {
    type: String,
    default: 'core.search',
  },
});

const coreStore = useCoreStore();

const searchBy = ref('');

const debouncedSearch = useDebounceFn((value: string) => {
  if (props.containerType !== AppCoreEnums.ContainerType.NotSpecifiedContainer) {
    coreStore.setContainerSearchBy(props.containerType, value);
  }
  emit('search-changed', value);
}, 300);

const onSearchByChanged = () => {
  debouncedSearch(searchBy.value);
};

const onClear = () => {
  searchBy.value = '';
  if (props.containerType !== AppCoreEnums.ContainerType.NotSpecifiedContainer) {
    coreStore.setContainerSearchBy(props.containerType, '');
  }
  emit('search-changed', '');
};
</script>
<template>
  <div
    class="relative w-full"
    :class="props.containerType != AppCoreEnums.ContainerType.NotSpecifiedContainer ? 'pl-[3px]' : 'pl-0'"
  >
    <!-- Search Icon -->
    <Icon icon="hugeicons:search-01" class="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />

    <!-- Input Text -->
    <InputText
      v-model="searchBy"
      class="!py-2 text-[16px] placeholder:dark:text-gray-200 pl-10 pr-10 w-full"
      :placeholder="$t(props.placeholder)"
      :ptOptions="{ mergeSections: true, mergeProps: true }"
      :pt="{ ...inputTextPreset }"
      @update:model-value="onSearchByChanged"
    />

    <!-- Close Button  -->
    <button
      v-if="searchBy.length > 0"
      class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
      @click="onClear"
    >
      <Icon icon="hugeicons:cancel-01" class="w-5 h-5" />
    </button>
  </div>
</template>
